import React, { useCallback } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import logo from "../../../assets/images/bglogo.svg";
import { getMemberCmsSelector, getMemberHeroCmsSelector } from "../../admin/dashboard/selector";
import DesktopVideo from "../vedioSlider/DesktopVideo";
import MobileVideo from "../vedioSlider/MobileVideo";
import { divideArrayEqually } from "../../../utils/commonFunctions";
import CustomButton from "../../../components/Buttons/CustomButton";

function HeroSection({ membershipData }) {
  const memberHeroData = useSelector(getMemberHeroCmsSelector);
  const userInfo = useSelector((state) => state?.my_account?.user_info);
  const memberData = useSelector(getMemberCmsSelector);

  const history = useHistory();

  const handleJoinForFree = useCallback(() => {
    if (userInfo?.auth_token) {
      toast.success("Thank you for being with us. You are already a customer");
    } else {
      window.location = `${membershipData?.hero_button_link || "/signup"}`;
    }
  }, [history, membershipData?.hero_button_link, userInfo?.auth_token]);

  const uniqueIdsArray = [];
  const resultArray = [];
  const numberOfParts = 3;

  memberData?.length > 0 &&
    memberData.forEach((item) => {
      if (!uniqueIdsArray.includes(item.id)) {
        uniqueIdsArray.push(item?.id);
        resultArray.push(item);
      }
    });

  const dividedArray = divideArrayEqually(resultArray, numberOfParts);

  return (
    <section className="banner bg-cyan overflow-hidden position-relative">
      <Image src={`${logo}`} alt="logo" className="bg-logo" height={540} width={540} />
      <Container className="h-100">
        <Row className="text-white justify-content-between align-items-center h-100">
          <Col lg={6} xl={5} className="py-5">
            <h2 className="fw-bold">{memberHeroData?.hero_title}</h2>
            <div
              id="mainContent"
              className="my-4 mb-5 text-lg hero_description"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: memberHeroData?.hero_description,
              }}
            />
            <div className="d-flex gap-2 flex-wrap align-items-center">
              <a href="/member-benefits" className="">
                <CustomButton className="text-nowrap" variant="rainbow" type="submit" gradient>
                  Exclusive Discounts
                </CustomButton>
              </a>
              {!userInfo?.auth_token && (
                <CustomButton className="text-nowrap" variant="rainbow" type="submit" gradient onClick={handleJoinForFree}>
                  {membershipData?.joining_button_text || "joining_button_text"}
                </CustomButton>
              )}
            </div>
          </Col>
          <DesktopVideo resultArray={dividedArray} />
        </Row>
      </Container>
      <MobileVideo resultArray={dividedArray} />
    </section>
  );
}
export default HeroSection;
